import React from 'react'

export function SvgClose({ width = 14, height = 14, className }) {
  return (
    <svg {...{ width, height, className }} xmlns="http://www.w3.org/2000/svg">
      <path d="M13.3.71a.996.996 0 00-1.41 0L7 5.59 2.11.7A.996.996 0 10.7 2.11L5.59 7 .7 11.89a.996.996 0 101.41 1.41L7 8.41l4.89 4.89a.996.996 0 101.41-1.41L8.41 7l4.89-4.89c.38-.38.38-1.02 0-1.4z" />
    </svg>
  )
}
